const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const absUrl = (u) => (!u ? "" : u.startsWith("/api") ? `${BACKEND_URL}${u}` : u);

// Cloudinary image thumbnail for ANY extension via on-the-fly transformation.
// Falls back to local variant pipeline / original URL for non-Cloudinary sources.
export function cldThumb(url, w = 500) {
  if (!url) return "";
  const u = absUrl(url);
  if (u.includes("res.cloudinary.com") && u.includes("/image/upload/")) {
    return u.replace("/image/upload/", `/image/upload/c_fill,w_${w},f_auto,q_auto/`);
  }
  if (u.includes("res.cloudinary.com") && u.includes("/upload/")) {
    return u.replace("/upload/", `/upload/c_fill,w_${w},f_auto,q_auto/`);
  }
  const m = u.match(/_full\.(webp|jpg|jpeg|png)$/i);
  if (m) return u.replace(/_full\.(webp|jpg|jpeg|png)$/i, `_med.${m[1]}`);
  return u;
}

// Cloudinary video poster (first frame) as a JPEG image URL.
export function cldVideoPoster(url, w = 500) {
  if (!url) return "";
  const u = absUrl(url);
  if (u.includes("res.cloudinary.com") && u.includes("/video/upload/")) {
    let out = u.replace("/video/upload/", `/video/upload/so_0,c_fill,w_${w}/`);
    out = out.replace(/\.(mp4|mov|webm|m4v|mpeg|mpg|avi|3gp)$/i, ".jpg");
    if (!/\.jpg$/i.test(out)) out += ".jpg";
    return out;
  }
  return "";
}
